import React from "react";
import {Steps, theme} from "antd";
import "./stepper.scss";

export interface StepConfig<T = any> {
    title: string;
    description: string;
    component: React.FC<T>,
    componentProps?: T
}

interface ShipModalProps {
    current: number;
    steps: StepConfig[];
    direction?: "horizontal" | "vertical";
}

export const Stepper: React.FC<ShipModalProps> = ({current, steps, direction = "horizontal"}) => {
    const {token} = theme.useToken();

    const stepConfig = steps[current];
    if (!stepConfig) {
        return <></>
    }

    const Component = stepConfig.component;

    return <div
        className={`stepper stepper--${direction}`}
        style={{
            "--stepper-finish-background": token.colorFillSecondary,
            "--stepper-finish-border": token.colorBorder,
            "--stepper-finish-color": token.colorTextSecondary,
            "--stepper-finish-line": token.colorBorderSecondary,
        } as React.CSSProperties}
    >
        <Steps current={current} direction={direction} size="small">
            {steps.map((step, key) => <Steps.Step key={key} title={step.title} description={step.description}/>)}
        </Steps>
        <div className="stepper__content">
            <Component {...stepConfig.componentProps} />
        </div>
    </div>
}
